import { ActionRegistry } from '@packages/table-builder/registry';

const charterStockClassActionsLoader = () => import('./charter-stock-class.actions');

/** VIEW_CHARTER_STOCK_CLASS infers domain `class`; map aliases without touching global registry. */
export function registerCharterStockClassActionAliases(): void {
  ActionRegistry.registerDomainLoader('class', charterStockClassActionsLoader);
  ActionRegistry.registerDomainLoader('charter', charterStockClassActionsLoader);
}
